var _excluded = ["target", "placement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useCallback, useEffect, useMemo, useState } from 'react';
import Floater from 'react-floater';
import { useTestId } from '../../../utils';
import { Box } from '../../internal';
import { Beacon } from './components';
import { TourPopover } from './components/TourPopover';
import { getElement, isElementVisible } from './tourtip.utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export var Tourtip = _ref => {
  var _defaultLabels$progre;

  var {
    run = true,
    steps,
    onTourStart,
    onNextClick,
    onPrevClick,
    onTourComplete,
    onTargetNotFound,
    onStepChange,
    onTourDismiss,
    onTourMinimize,
    onBeaconClick,
    defaultLabels,
    stepIndex,
    defaultStepIndex = stepIndex !== null && stepIndex !== void 0 ? stepIndex : 0,
    defaultIsMinimize = false,
    enableMinimize = false,
    disableScrolling = false,
    'data-testid': dataTestId = 'tourtip'
  } = _ref;
  var [currentIndex, setCurrentIndex] = useState(stepIndex !== null && stepIndex !== void 0 ? stepIndex : defaultStepIndex);
  var [isRunning, setIsRunning] = useState(run);
  var [isMinimize, setIsMinimize] = useState(defaultIsMinimize && !isRunning);
  var isControlled = stepIndex !== undefined;
  var step = useMemo(() => steps[isControlled ? stepIndex : currentIndex], [steps, isControlled, stepIndex, currentIndex]);

  var {
    target,
    placement = 'bottom-end'
  } = step,
      stepProps = _objectWithoutProperties(step, _excluded);

  var isLastStep = currentIndex === steps.length - 1;
  var [action, setAction] = useState('ready');
  useEffect(() => {
    if (run !== undefined) {
      setIsRunning(run);
    }
  }, [run]);
  useEffect(() => {
    if (enableMinimize) {
      setIsRunning(!defaultIsMinimize);
      setIsMinimize(defaultIsMinimize);
    }
  }, [enableMinimize, defaultIsMinimize]);
  useEffect(() => {
    if (isControlled) {
      setCurrentIndex(stepIndex);
    }
  }, [isControlled, stepIndex]);
  var handleBeaconClick = useCallback(() => {
    if (enableMinimize && isMinimize) {
      setIsRunning(true);
      setIsMinimize(false);
      onBeaconClick === null || onBeaconClick === void 0 ? void 0 : onBeaconClick({
        currentIndex
      });
    }
  }, [currentIndex, enableMinimize, isMinimize, onBeaconClick]);
  var resetTour = useCallback(() => {
    setIsRunning(false);
    if (isControlled) return;
    setCurrentIndex(defaultStepIndex);
  }, [defaultStepIndex, isControlled]);
  var handleMinimizeClick = useCallback(() => {
    if (enableMinimize) {
      setIsRunning(false);
      setIsMinimize(true);
      onTourMinimize === null || onTourMinimize === void 0 ? void 0 : onTourMinimize({
        currentIndex
      });
    }
  }, [enableMinimize, onTourMinimize, currentIndex]);
  var handleNextClick = useCallback(() => {
    setAction('next');

    if (isLastStep) {
      resetTour();
      onTourComplete === null || onTourComplete === void 0 ? void 0 : onTourComplete({
        currentIndex
      });
    } else if (currentIndex >= 0) {
      var newIndex = currentIndex + 1;
      onNextClick === null || onNextClick === void 0 ? void 0 : onNextClick({
        currentIndex,
        newIndex: !isControlled ? newIndex : undefined
      });
      if (isControlled) return;
      setCurrentIndex(newIndex);
    }
  }, [currentIndex, isLastStep, isControlled, onNextClick, onTourComplete, resetTour]);
  var handlePrevClick = useCallback(() => {
    var newIndex = currentIndex - 1;
    setAction('prev');
    onPrevClick === null || onPrevClick === void 0 ? void 0 : onPrevClick({
      currentIndex,
      newIndex: !isControlled ? newIndex : undefined
    });
    if (isControlled) return;
    setCurrentIndex(newIndex);
  }, [currentIndex, isControlled, onPrevClick]);
  var handleDismissClick = useCallback(() => {
    resetTour();
    onTourDismiss === null || onTourDismiss === void 0 ? void 0 : onTourDismiss({
      currentIndex
    });
  }, [currentIndex, onTourDismiss, resetTour]);
  useEffect(() => {
    if (!isRunning) return;
    var element = getElement(target);
    var elementExists = !!element;

    if (elementExists && isElementVisible(element)) {
      if (action === 'ready' && isRunning && currentIndex === defaultStepIndex) {
        onTourStart === null || onTourStart === void 0 ? void 0 : onTourStart({
          currentIndex
        });
        setAction('start');
      }

      if (!disableScrolling) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    } else {
      onTargetNotFound === null || onTargetNotFound === void 0 ? void 0 : onTargetNotFound({
        currentIndex,
        action
      });
      console.warn(elementExists ? 'Target not visible' : 'Target not mounted', step); //eslint-disable-line no-console

      var newIndex = action === 'prev' ? currentIndex - 1 : currentIndex + 1;

      if (currentIndex >= 0 && action !== 'prev') {
        if (isLastStep) {
          resetTour();
          onTourComplete === null || onTourComplete === void 0 ? void 0 : onTourComplete({
            currentIndex
          });
        } else {
          if (isControlled) return;
          onStepChange === null || onStepChange === void 0 ? void 0 : onStepChange({
            currentIndex,
            newIndex: !isControlled ? newIndex : undefined
          });
          setCurrentIndex(newIndex);
        }
      } else {
        if (isControlled) return;
        onStepChange === null || onStepChange === void 0 ? void 0 : onStepChange({
          currentIndex,
          newIndex: !isControlled ? newIndex : undefined
        });
        setCurrentIndex(newIndex);
      }
    }
  }, [isControlled, isRunning, target, currentIndex, step, isLastStep, action, defaultStepIndex, disableScrolling, onStepChange, onTourComplete, onTargetNotFound, onTourStart, resetTour]);
  var progressText = (_defaultLabels$progre = defaultLabels === null || defaultLabels === void 0 ? void 0 : defaultLabels.progressLabel) !== null && _defaultLabels$progre !== void 0 ? _defaultLabels$progre : defaultLabels !== null && defaultLabels !== void 0 && defaultLabels.progressSeparator ? "".concat(currentIndex + 1, " ").concat(defaultLabels.progressSeparator, " ").concat(steps.length) : undefined;
  var getTestId = useTestId(dataTestId);
  return /*#__PURE__*/_createElement(Box, _objectSpread(_objectSpread({
    "data-component": "Tourtip"
  }, getTestId()), {}, {
    key: "Tourtip-".concat(currentIndex),
    "data-state": isRunning ? 'open' : 'closed'
  }), /*#__PURE__*/_jsx(Floater, {
    open: isMinimize || isRunning,
    component: /*#__PURE__*/_jsx(TourPopover, _objectSpread(_objectSpread(_objectSpread({}, stepProps), getTestId("popover-".concat(currentIndex))), {}, {
      placement: placement,
      isOpen: isRunning,
      nextButtonLabel: (step === null || step === void 0 ? void 0 : step.nextButtonLabel) || defaultLabels.nextButtonLabel,
      prevButtonLabel: currentIndex > defaultStepIndex ? (step === null || step === void 0 ? void 0 : step.prevButtonLabel) || defaultLabels.prevButtonLabel : undefined,
      footerText: progressText,
      onNextClick: handleNextClick,
      onPrevClick: handlePrevClick,
      onCloseClick: handleDismissClick,
      onOutsideClick: handleMinimizeClick,
      children: /*#__PURE__*/_jsx(Beacon, _objectSpread({
        onClick: handleBeaconClick,
        cursor: enableMinimize ? 'pointer' : 'default'
      }, getTestId("beacon-".concat(currentIndex))))
    })),
    target: target,
    offset: -24,
    placement: placement,
    styles: {
      floaterOpening: {
        filter: 'none'
      }
    },
    hideArrow: true
  }));
};
Tourtip.displayName = 'Tourtip';
//# sourceMappingURL=Tourtip.js.map